$(document).ready(function() { 
  
  $('#EnquireForPrice').on('click', function() {
    var form = $("#ProductEnquiryForm").length ? $("#ProductEnquiryForm") : $("#ContactForm");

    if(form.length){
      $('html, body').animate({
        scrollTop: form.offset().top - 200
      }, 1000);
    }
  });
  
  $('.inquire-product-button').on('click', function() {
    var container = $(this).closest('.inquire-product');
    var txt = $(this).text() == 'View Less' ? 'View More' : 'View Less';
    $(this).text(txt);
    container.find('.grid__item.grid__item_toggle').toggleClass('grid__item_hidden');
  });
  
  $('#HeaderMenu-menu').on('click', function() {
    $('body').toggleClass('header-drawer-open')
  });

  $('.product-video .play-pause').on('click', function() {
    var video = $(this).closest('.product-video').find('video');
    if ($(this).hasClass('pause')) {
      video.get(0).pause();
    } else {
      video.get(0).play();
    }
    $(this).toggleClass('pause play');
  });

  $('.tooltip-trigger .trigger').on('click', function() {
    var id = $(this).parent().attr('tooltip-id');
    $('body').addClass('overflow-hidden')
    $('.tooltip[tooltip-id="' + id + '"]').addClass('active');
  });

  $('.tooltip').on('click', function(e) {
    if (e.target !== this) {
      return;
    }
    $('body').removeClass('overflow-hidden')
    $('.tooltip').removeClass('active');
  });

  $('.tooltip-close').on('click', function(e) {
    $('body').removeClass('overflow-hidden')
    $('.tooltip').removeClass('active');
  });

  if (window.location.hash == '#AppointmentForm') {
    $('body').addClass('appointment-drawer-active');
  }



  $('#AppointmentForm').on('submit', function() {
    var countryCode = $(this).find('.phone-code').text();
    var phone = $(this).find('#ContactForm-number').val();
    $(this).find('#ContactNumber').val(countryCode + phone);

    $('.multiple-checkbox').each(function() {
      var checkBoxes = [];
      $(this).find('[type="checkbox"]:checked').each(function() {
        checkBoxes.push($(this).val());
      });
      $(this).find('.multiple-checkbox--hidden').val(checkBoxes.join(', '))
    });
    
  });


  $('#ContactForm-country').on('change', function() {
    var countryCode = $(this).find('option:selected').val();
    $(this).closest('.appointment_field-row').find('.phone-code').text('+' + countryCode);
  });


  $('[href="#appointment"]').on('click', function(e) {
    e.preventDefault();
    $('body').addClass('appointment-drawer-active')
  })

  $('[href="#inquire-product"]').on('click', function(e) {
    e.preventDefault();
    var productName = $(this).attr('product-name');
    var productID = $(this).attr('product-id');
    $('#AppointmentForm').prepend('<input type="hidden" name="contact[Product ID]" value="' + productID + '">')
    $('#AppointmentForm').prepend('<input type="hidden" name="contact[Product Name]" value="' + productName + '">')
    $('body').addClass('appointment-drawer-active');
  })
  

  $('.appointment-form--close .icon, #AppointmentFormDrawerOverlay').on('click', function() {
    $('#AppointmentForm [name="contact[Product ID]"]').remove();
    $('#AppointmentForm [name="contact[Product Name]"]').remove();
    $('body').removeClass('appointment-drawer-active');
  });

  $('.multicolumn-card__video').on('click', function() {
    $(this).toggleClass('playing')
    var video = $(this).find('video').get(0);
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  $('.banner-expanding-text--trigger').on('click', function() {
    $(this).closest('.section-banner-expanding-text').find('.banner-expanding-text--content').slideToggle();
    var text = $(this).text() == 'Close' ? $(this).attr('text') : 'Close';
    $(this).text(text)
  });





  $('.shop-the-look--trigger').on('click', function() {
    $('body').addClass('overflow-hidden')
    window.dispatchEvent(new Event('resize'));
    $(this).closest('.section-shop-the-look').addClass('shop-the-look--active');
  });

  $('.shop-the-look--close .icon, #ShopTheLookDrawerOverlay').on('click', function() {
    $('body').removeClass('overflow-hidden')
    $(this).closest('.section-shop-the-look').removeClass('shop-the-look--active');
  });


});
